import { useLanguage } from './languageContext';
import { translations } from './translations';

export const useTranslation = () => {
  const { language } = useLanguage();

  const t = (key, params = {}) => {
    const keys = key.split('.');
    let translation = translations[language];
    
    for (const k of keys) {
      translation = translation?.[k];
    }

    if (!translation) {
      console.warn(`Translation missing for key: ${key} in language: ${language}`);
      return key;
    }

    // Replace parameters
    return Object.entries(params).reduce((str, [key, value]) => {
      return str.replace(`{${key}}`, value);
    }, translation);
  };

  return { t };
};